import { OfficeBase } from "@core/base/office-base";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";

export class WebOffice extends OfficeBase implements OfficeBase {
    private error = 'Method not implemented'
    getHost(): IOfficeHost {
        throw new Error(this.error)
    }

    public override async showDialog(): Promise<void> {
        throw new Error(this.error)
    }

    public override async setSelectedTextAsync(): Promise<void> {
        throw new Error(this.error)
    }

    public override async setSelectedImageAsync(): Promise<void> {
        throw new Error(this.error)
    }
}
